<h1 [class.pdf]="pdf()">
  <button mat-icon-button class="side-bar-toggler" (click)="onOpenClick($event)" >
    <mat-icon>menu</mat-icon>
  </button>
  {{ route.title | async | uppercase }}
</h1>
